<template>
  <!-- <AddButton @click="IsCreate()" v-if="showButton" :btnname=" $t('btn.plusaddnew')"></AddButton>
    <EditIcon @click="IsEdit()" v-if="!showButton" /> -->
  <Dialog
    :modal="true"
    v-model:visible="showDialog"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    :header="
      model ? $t('stores.Rack.EditFormHeader') : $t('stores.Rack.FormHeader')
    "
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="8">
          <div class="field">
            <!-- <label path="storeid">{{ $t('rack.name') }}</label> -->
            <TextField
              v-model="dataModel.Name"
              type="text"
              placeholder=" "
              clearable
              name="Rack Name"
              :label="$t('rack.name')"
              :rules="{ required: true }"
              :requiredIcon="true"
              id="Rack Name"
              case="Capital"
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <!-- <StoreDropDown v-model="SelectOption.StoreId" :items="SelectOption.StoreOptions"
              @update:modelValue="LoadRoom" name="Store Mapping" :label="$t('rack.SMapping')"
              :rules="{ required: true }" :requiredIcon="true" id="Store Mapping" /> -->
            <!-- <label path="storeid">{{ $t('rack.SMapping') }} </label> -->
            <StoreDropDown
              v-model="SelectOption.StoreId"
              :items="SelectOption.StoreOptions"
              @update:modelValue="
                () => {
                  SelectStore(SelectOption.StoreId), LoadRoom();
                }
              "
              name="Store Mapping"
              :label="$t('rack.SMapping')"
              :rules="{ required: true }"
              :requiredIcon="true"
              id="Store Mapping"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8" class="addcircle_field">
          <div class="field">
            <!-- <label path="storeid">{{ $t('rack.RoomMapping') }} </label> -->
            <CustomDropDown
              v-model="SelectOption.RoomId"
              :items="SelectOption.RoomOptions"
              name="Room Mapping"
              :label="$t('rack.RoomMapping')"
              :rules="{ required: true }"
              :requiredIcon="true"
              id="Room Mapping"
            />
            <!-- <span class="float-end blue-txt mt-3" @click="FunctionRights(EntityIds.Room, 'Room')">+ Add Room</span> -->
          </div>
          <span
            class="add_circle"
            @click="FunctionRights(EntityIds.Room, 'Room')"
            ><i class="pi pi-plus"></i
          ></span>
        </b-col>
      </b-row>
      <!-- <b-row>
                <b-col sm="6">
                    <div class="field">
                        <label path="storeid">{{ $t('rack.RowMapping') }} </label>
                        <CustomDropDown v-model="SelectOption.RowId" :items="SelectOption.RowOptions" name="Row Mapping"
                            :label="$t('rack.RowMapping')" :rules="{ required: true }" :requiredIcon="true" />
                    </div>
                </b-col>
            </b-row> -->
      <b-row>
        <b-col>
          <Footer
            @cancel="(showDialog = false), IsClear()"
            :cancelhide="false"
            :label="label"
            :loading="Saveloader"
          />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
  <RoomCreation
    v-if="DialogShow.Room"
    @load="LoadRoom(), (DialogShow.Room = false)"
    @close="DialogShow.Room = false"
    @loaderhide="loading = false"
    @loadershow="loading = true"
    :OperationID="ObjOperationId"
    :EntityId="EntityIds.Room"
  />
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, PropType, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import CustomDropDown from "../../../../../../components/FormComponents/Dropdown.vue";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import storeService from "../../../../Service/StoreService";
import commonservice from "../../../../Service/RackService";
import roomService from "../../../../Service/RoomService";
import rowService from "../../../../Service/RowService";

import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import RoomCreation from "../../../Masters/Stores/RoomMaster/RoomCreation.vue";
import MastersService from "../../../../Service/MastersService";
import { checkPermission } from "../../../../Service/AccessControl";
import { useToast } from "primevue/usetoast";
import StoreDropDown from "../../../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";
export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Footer,
    CustomDropDown,

    TextField,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
    RoomCreation,
    StoreDropDown,
  },
  setup(props, { emit }) {
    /*Declaration starts*/
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let loading = ref(false);
    let Saveloader = ref(false);
    const toast = useToast();
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }
    let Entitydata = ref({
      EntityId: 0,
    });
    Entitydata.value.EntityId = props.EntityId;
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const dataModel = ref({
      Name: "",
      StoreId: 0,
      RoomId: 0,
      RowId: 0,
      Id: 0,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
      StoreBrMapId: 0,
    });
    const copydataModel = JSON.parse(JSON.stringify(dataModel.value));
    const SelectOption = ref({
      StoreId: ref(),
      StoreOptions: [],
      RoomId: ref(),
      RoomOptions: [],
      RowId: ref(),
      RowOptions: [],
    });
    const copySelectOption = JSON.parse(JSON.stringify(SelectOption.value));
    const successpop = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);

    // Entitydata.value = localStorage.getItem("EntityData");
    // Entitydata.value = JSON.parse(Entitydata.value);
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    let DialogShow = ref({
      Room: false,
    });
    let EntityIds = ref({
      Room: 98,
    });
    /*Declaration ends*/
    /* Methods Starts */
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });
    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      }
      // else if (event.altKey && event.key == 'n') {
      //     showDialog.value = true;
      // }
      else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
      // else if (event.key == 'e') {
      //     IsEdit()
      // }
      // else if (event.key == 'Escape') {

      //     IsClear()
      // }
    }
    function SelectStore(value) {
      if (value) {
        let store: any = SelectOption.value.StoreId.Id;
        dataModel.value.StoreId = store;
        dataModel.value.StoreBrMapId =
          SelectOption.value.StoreId.StoreBranchMapId;
        dataModel.value.BranchId = SelectOption.value.StoreId.BranchId;
      }
    }
    //Store  Select Load function
    function IsCreate() {
      showDialog.value = true;
    }
    // async function LoadStore() {
    //   try {
    //     const result = await storeService.getStoreList();
    //     console.log(result);
    //     SelectOption.value.StoreOptions = result["result"].filter((i1) => i1.IsActive == true && i1.HospitalId == HospitalId && i1.BranchId == BranchId).map((item) => {
    //       item.name = item.Name;
    //       item.value = item.Id;
    //       return item;
    //     });
    //   } catch (error) { }
    // }

    //Room Load Based on Store
    async function LoadRoom() {
      debugger;
      try {
        SelectOption.value.RoomId = null;
        SelectOption.value.RoomOptions = [];
        console.log(SelectOption.value.StoreId);
        let Id = dataModel.value.StoreId;
        let StoreBrMapId = dataModel.value.StoreBrMapId;

        const result = await roomService.getRoomByStoreId(Id, StoreBrMapId);
        console.log(result);
        SelectOption.value.RoomOptions = result["result"]
          .filter((i1) => i1.IsActive == true)
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {}
    }

    //Row Load Based on Room
    async function LoadRow() {
      debugger;
      try {
        SelectOption.value.RowId = null;
        SelectOption.value.RowOptions = [];
        let Id = SelectOption.value.RoomId;

        const result = await rowService.getRowByRoomId(Id);
        console.log(result);
        SelectOption.value.RowOptions = result["result"].map((item) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {}
    }

    //Insert Update
    const IsSubmit = async () => {
      emit("loadershow");
      debugger;
      Saveloader.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloader.value = false;
        return;
      }

      let room: any = SelectOption.value.RoomId;
      dataModel.value.RoomId = room;
      // let row: any = SelectOption.value.RowId
      // dataModel.value.RowId = row
      dataModel.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      dataModel.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      dataModel.value.HospitalId = HospitalId;
      dataModel.value.ModifiedBy = UserId;
      dataModel.value.CreatedBy = UserId;
      dataModel.value.EntityId = Number(Entitydata.value.EntityId);

      try {
        let result: any;
        let msg = "";
        if (dataModel.value.Id != 0) {
          dataModel.value.EntityOperationId = props.OperationID.UpdateId;
          result = await commonservice.updateRack(dataModel.value);
          msg = result["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (result["result"] == "Already" && msg == null) {
            Saveloader.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloader.value = false;
            updatepop.value = true;
          } else {
            Saveloader.value = false;
            alert("something went wrong");
          }
        } else {
          dataModel.value.EntityOperationId = props.OperationID.CreateId;
          result = await commonservice.insertRack(dataModel.value);
          msg = result["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (result["result"] == "Already" && msg == null) {
            Saveloader.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloader.value = false;
            successpop.value = true;
          } else {
            Saveloader.value = false;
            alert("something went wrong");
          }
        }
      } catch (error) {
        loading.value = false;
        Saveloader.value = false;
      }
    };

    //Edit Rack
    async function IsEdit() {
      showDialog.value = true;
      emit("loadershow");
      debugger;
      try {
        // dataModel.value.Id = model.value.Id;
        label.value = t("btn.update");
        const result = await commonservice.getRackById(model.value.Id);
        let resfields = result["result"];
        // alert(JSON.stringify(resfields))

        Object.keys(dataModel.value).forEach((key) => {
          if (resfields[key]) dataModel.value[key] = resfields[key];
        });
        SelectOption.value.StoreId = resfields.StoreBrMapId;
        LoadRoom();
        SelectOption.value.RoomId = resfields.RoomId;
        LoadRow();
        //SelectOption.value.RowId = resfields.RowId;
        // dataModel.value.StoreId = resfields.StoreId;
        dataModel.value.StoreId = resfields.StoreBrMapId;

        dataModel.value.CreatedAt = "2023-02-03T11:05:31.945Z";
        dataModel.value.StoreBrMapId = resfields.StoreBrMapId;
        emit("loaderhide");
      } catch (error) {
        emit("loaderhide");
      }
    }
    //Clear
    function IsClear() {
      Object.assign(dataModel.value, copydataModel);
      Object.assign(SelectOption.value, copySelectOption);
      // LoadStore();
      showDialog.value = false;
      //emit("update:trigger", false);
      emit("update:selectedItem", undefined);
      emit("close");
    }
    //Created Sucessfully Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      showDialog.value = false;
      emit("load");
      IsClear();
    }
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      dataModel.value.Name = "";
      //showDialog.value = true
    }
    //Masters ShorCut Creation

    async function FunctionRights(EntityId, FieldType) {
      debugger;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    /*Methods End*/

    return {
      Saveloader,
      EntityIds,
      FunctionRights,
      DialogShow,
      ObjOperationId,
      IsSubmit,
      IsEdit,
      dataModel,
      SelectOption,
      showModal: ref(false),
      // LoadStore,
      LoadRoom,
      LoadRow,
      IsClear,
      showDialog,
      IsCreate,
      successpop,
      updatepop,
      closetrigger,
      alreadyclosetrigger,
      alreadyexistpop,
      label,
      loading,
      model,
      SelectStore,
    };
  },

  // async created() {
  //   this.LoadStore();
  // },
});
</script>
